<!--补录数据列表页面-->
<template>
  <div class="page-container">
    <Header></Header>

    <div class="main-layout">
      <div class="sidebar">
        <MenuList></MenuList>
      </div>

      <div class="content">
        <!-- 操作栏 -->
        <div class="action-bar">
          <el-button type="primary" plain size="small" @click="backToBrowseAllData">
            <i class="el-icon-arrow-left"></i>返回数据
          </el-button>
          <div class="action-right">
            <el-button type="primary" size="small" @click="addManualInput">
              <i class="el-icon-plus"></i>添加补录数据
            </el-button>
            <el-button type="primary" plain size="small" @click="loadData">
              <i class="el-icon-refresh"></i>刷新
            </el-button>
          </div>
        </div>

        <!-- 表格信息卡片 -->
        <div class="info-card">
          <h2 class="form-title">{{form_name}}</h2>
          <div class="form-meta">
            <span class="meta-item">
              <i class="el-icon-document"></i>
              <span>ID：<strong>{{form_id}}</strong></span>
            </span>
            <span class="meta-item">
              <i class="el-icon-info-outline"></i>
              <span>这里只显示手工补录的数据</span>
            </span>
          </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-container">
          <el-table ref="dataList" :key="tableKey" :data="tableData" stripe class="data-table"
            :header-cell-style="{background:'#f5f7fa',color:'#606266',fontWeight:'600'}" v-loading="loading" height="500"
            border>

            <el-table-column label="补录时间" prop="submit_time" align="center" width="180" fixed>
              <template slot-scope="scope">
                <span>{{scope.row.submit_time || '-'}}</span>
              </template>
            </el-table-column>

            <el-table-column v-for="(header) in headers" :key="header.field_name" :prop="header.field_name"
              :label="header.field_name" header-align="center" align="center" resizable min-width="140">
              <template slot-scope="scope">
                <div class="cell-text">
                  {{scope.row[header.field_name] || '-'}}
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" align="center" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="deleteRecord(scope.row)" type="text" size="small" class="delete-btn">
                  <i class="el-icon-delete"></i>删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="table-footer">
            <span class="data-count">共 <strong>{{tableData.length}}</strong> 条补录数据</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        form_id: '',
        form_name: '',
        headers: [],
        inputedDataList: [],
        tableData: [],
        tableKey: 0,
        loading: false
      }
    },
    created() {
      this.form_id = this.$route.params.form_id
      this.form_name = this.$route.params.form_name

      // 先加载表格列,列确定后再加载数据,避免表格首次渲染时列错位
      this.loadFields()
    },
    methods: {
      loadFields() {
        let that = this
        var requestUrl = '/checking/web/_load_manual_input_fields.jsp'
        this.axios.get(requestUrl, {
          params: {
            form_id: that.form_id
          }
        }).then(function (response) {
          if (response.data.result === '1') {
            that.headers = response.data.fields
            that.form_name = that.form_name || response.data.form.form_name

            // 列结构变化后重建表格,保证列宽与固定列计算正确
            that.tableKey = that.tableKey + 1
          }

          that.loadData()
        }).catch(function (error) {
          console.log(error)
          that.loadData()
        })
      },
      loadData() {
        this.loading = true
        let that = this
        var requestUrl = '/checking/web/_load_manual_input_list.jsp'
        this.axios.get(requestUrl, {
          params: {
            form_id: that.form_id
          }
        }).then(function (response) {
          that.inputedDataList = response.data.inputed_data_list || []
          that.buildTableData()
          that.loading = false
          that.refreshTable()
        }).catch(function (error) {
          console.log(error)
          that.loading = false
        })
      },
      refreshTable() {
        var that = this

        this.$nextTick(function () {
          if (that.$refs.dataList) {
            that.$refs.dataList.doLayout()
          }
        })
      },
      buildTableData() {
        var rows = []

        for (var i = 0; i < this.inputedDataList.length; i++) {
          var item = this.inputedDataList[i]
          var row = {
            data_row_id: item.data_row_id,
            submit_time: item.submit_time
          }

          var fields = item.fields || []
          for (var k = 0; k < fields.length; k++) {
            row[fields[k].field_name] = fields[k].field_value
          }

          rows.push(row)
        }

        this.tableData = rows
      },
      addManualInput() {
        this.$router.push({
          name: 'manual_input_form',
          params: {
            form_id: this.form_id,
            form_name: this.form_name
          }
        })
      },
      deleteRecord(row) {
        var that = this
        this.$confirm('要删除本条补录数据吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(function () {
          that.deleteRow(row.data_row_id)
        }).catch(function () {})
      },
      deleteRow(data_row_id) {
        this.loading = true
        let that = this
        var requestUrl = '/checking/web/_delete_manual_input_data.jsp'
        this.axios.get(requestUrl, {
          params: {
            form_id: that.form_id,
            data_row_id: data_row_id
          }
        }).then(function (response) {
          if (response.data.result === '1') {
            that.$message.success('删除成功!')
            that.loadData()
          } else {
            that.$message.error(response.data.message || '删除失败!')
            that.loading = false
          }
        }).catch(function (error) {
          console.log(error)
          that.loading = false
        })
      },
      backToBrowseAllData() {
        this.$router.push({
          name: 'browse_all_data',
          params: {
            form_id: this.form_id,
            form_name: this.form_name
          }
        })
      }
    }
  }
</script>

<style scoped>
  .page-container {
    min-height: 100vh;
    background: #f5f7fa;
    display: flex;
    flex-direction: column;
  }

  .main-layout {
    flex: 1;
    display: flex;
  }

  .sidebar {
    width: 220px;
    background: #fff;
    border-right: 1px solid #e8ecf1;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    padding: 20px;
    overflow: auto;
  }

  .action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  .action-right {
    display: flex;
    gap: 12px;
  }

  .info-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }

  .form-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
  }

  .form-meta {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .meta-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: #666;
  }

  .meta-item i {
    color: #1485FB;
    font-size: 16px;
  }

  .table-container {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  }

  .data-table {
    width: 100%;
  }

  .cell-text {
    font-size: 13px;
    color: #333;
    padding: 4px;
  }

  .delete-btn {
    color: #f56c6c;
  }

  .table-footer {
    text-align: center;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
    margin-top: 8px;
  }

  .data-count {
    font-size: 14px;
    color: #666;
  }

  .data-count strong {
    color: #1485FB;
    font-size: 16px;
    margin: 0 4px;
  }

  @media (max-width: 768px) {
    .sidebar {
      display: none;
    }

    .content {
      padding: 12px;
    }

    .action-bar {
      flex-direction: column;
      gap: 12px;
      align-items: stretch;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/manual_input_list.vue